module.exports = __webpack_public_path__ + "img/print-jcqzzfbpay.f686a357.png";